import { Component, Input, ViewEncapsulation } from '@angular/core';
import { AuditTrialDetails } from '../../shared/models/audits/audit-trial-details';
import { HardCopyActivityTransitionDetails } from '../models/hardcopyactivity-transition-details';
import { HardCopyActivityLifeCycle } from '../models/hardcopyactivity-life-cycle';
import { HardCopyActivityAuditTrialDetails } from '../models/hardcopyactivity-audit-trial-details';
import { HardcopyactivityAuditService } from '../services/hardcopyactivity-audit.service';
import { SharedConstants } from '../../shared/constants/shared-constants';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-hardcopyactivity-audit-trial',
  templateUrl: './hardcopyactivity-audit-trial.component.html',
  styleUrls: ['./hardcopyactivity-audit-trial.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class HardcopyactivityAuditTrialComponent {
  @Input() hardcopyactivityId: string = '';
  auditAttributeDetailsOfTransaction!: AuditTrialDetails;
  hardCopyActivityTransitionDetails!: HardCopyActivityTransitionDetails;
  hardCopyActivityLifeCycleDetails: HardCopyActivityLifeCycle[] = [];
  hardCopyActivityAuditSummaryDetails: HardCopyActivityAuditTrialDetails[] = [];
  showLoader:boolean = false;
  isHardCopyActivityAuditDetailsDataLoaded = false;
  constructor(private hardCopyActivityAuditService: HardcopyactivityAuditService, private messageService: MessageService) {

  }
  ngOnInit(): void {
    this.showLoader = true
    this.hardCopyActivityAuditService.getHardCopyActivityTransitionDetails(this.hardcopyactivityId)
      .subscribe({
        next: (hardCopyActivityTransitionDetails) => {
          this.hardCopyActivityTransitionDetails = hardCopyActivityTransitionDetails;
          this.hardCopyActivityLifeCycleDetails = hardCopyActivityTransitionDetails.hardCopyActivityLifeCycleDetails;
          this.hardCopyActivityAuditSummaryDetails = hardCopyActivityTransitionDetails.hardCopyActivityAuditTrialDetails;
          this.auditAttributeDetailsOfTransaction = hardCopyActivityTransitionDetails.hardCopyActivityAuditTrialDetails[0];
          this.isHardCopyActivityAuditDetailsDataLoaded = true;
          this.notifyMissingAttributesIfAny();
          this.showLoader = false;
        },
        error: (error) => {
          this.messageService.add({
            severity: SharedConstants.Severity_Error,
            summary: SharedConstants.Audit_Fail_Error_Message,
            sticky: true
          });
          this.showLoader = false;
        }
      });
  }
  showAuditItemDetails = (auditAttributeDetails: any) => {
    this.auditAttributeDetailsOfTransaction = auditAttributeDetails;
  }

  private hasMissingAttributes(): boolean {
    const summary = this.hardCopyActivityAuditSummaryDetails;
    return !!summary?.some(d => d?.attributeDetails?.some(a => a?.isAttributeValueMissing));
  }
  private notifyMissingAttributesIfAny(): void {
    if (this.hasMissingAttributes()) {
      this.messageService.add({
        severity: SharedConstants.Severity_Warning,
        summary: SharedConstants.AuditTrail_AttributeMissing_Message,
        life: 20000,
      });
    }
  }
}
